import { useCallback, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import {
  changeFiscalDetailFilterStore,
  reportFiscalDetailFilterCountrySelector,
  reportFiscalDetailFilterStoreSelector,
  reportOpStructuresFilterAgreementSelector,
  reportOpStructuresFilterCompanySelector,
  reportOpStructuresFilterManagementSelector,
  reportOpStructuresFilterRegionalManagementSelector,
  reportOpStructuresFilterRegionSelector,
  reportOpStructuresFilterSupervisionSelector,
} from '../../../state';
import { Stores } from '../../../types';
import { StoreSelect } from '../../selects';

const StoreFilter: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const country = useSelector(reportFiscalDetailFilterCountrySelector);
  const countryCode = (country.length === 1 ? country[0].countryCode : undefined) as string;
  const storesSelected = useSelector(reportFiscalDetailFilterStoreSelector);
  const regionalManagement = useSelector(reportOpStructuresFilterRegionalManagementSelector);
  const regions = useSelector(reportOpStructuresFilterRegionSelector);
  const managements = useSelector(reportOpStructuresFilterManagementSelector);
  const supervisions = useSelector(reportOpStructuresFilterSupervisionSelector);
  const agreements = useSelector(reportOpStructuresFilterAgreementSelector);
  const companies = useSelector(reportOpStructuresFilterCompanySelector);

  const handleChange = useCallback(
    (value: Stores[]) => dispatch(changeFiscalDetailFilterStore(value)),
    [dispatch]
  );

  return (
    <StoreSelect
      label={t('toolbar.labels.store')}
      limitTags={3}
      countryCode={countryCode}
      value={storesSelected}
      onChange={handleChange}
      regionalManagements={regionalManagement}
      regions={regions}
      managements={managements}
      supervisions={supervisions}
      agreements={agreements}
      companies={companies}
      selectAll
    />
  );
};

export default StoreFilter;
